import { render, staticRenderFns } from "./weiXinMessage.vue?vue&type=template&id=918230e6&scoped=true&"
import script from "./weiXinMessage.vue?vue&type=script&lang=js&"
export * from "./weiXinMessage.vue?vue&type=script&lang=js&"
import style0 from "./weiXinMessage.vue?vue&type=style&index=0&id=918230e6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918230e6",
  null
  
)

component.options.__file = "weiXinMessage.vue"
export default component.exports